import React from 'react';

var TUXTextFieldFooter = function TUXTextFieldFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("footer", {
    className: "py-8 P2-Regular text-color-TextTertiary"
  }, children);
};

export { TUXTextFieldFooter };
//# sourceMappingURL=TUXTextFieldFooter.js.map
